/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The OneOfworkflowsPersonalizationRuleSetInputsValue model module.
 * @module model/OneOfworkflowsPersonalizationRuleSetInputsValue
 * @version v0.3
 */
export default class OneOfworkflowsPersonalizationRuleSetInputsValue {
  /**
   * Constructs a new <code>OneOfworkflowsPersonalizationRuleSetInputsValue</code>.
   * @alias module:model/OneOfworkflowsPersonalizationRuleSetInputsValue
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>OneOfworkflowsPersonalizationRuleSetInputsValue</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OneOfworkflowsPersonalizationRuleSetInputsValue} obj Optional instance to populate.
   * @return {module:model/OneOfworkflowsPersonalizationRuleSetInputsValue} The populated <code>OneOfworkflowsPersonalizationRuleSetInputsValue</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OneOfworkflowsPersonalizationRuleSetInputsValue();
    }
    return obj;
  }
}
